import { AntDesign } from "@expo/vector-icons";
import { Spacings } from "react-native-ui-lib";
import { Button, Page, VStack, Text } from "@towersystems/roam-common-native";

export interface PageErrorOccurredProps {
  errorMessage?: string;
  onRetry?: () => void;
}

const GENERIC_ERROR_MESSAGE = "An error occurred, retry or contact support.";

export function PageErrorOccurred({
  errorMessage,
  onRetry,
}: PageErrorOccurredProps) {
  const retryMarkup = onRetry ? (
    <Button
      style={{
        display: "flex",
        marginTop: Spacings.s4,
      }}
      label="Retry"
      onPress={onRetry}
    />
  ) : null;

  return (
    <Page>
      <VStack
        spacing={Spacings.s2}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text variant="heading">Whoops!...</Text>
        <AntDesign name="warning" size={50} color="#FB5F68" />
        <Text>{errorMessage || GENERIC_ERROR_MESSAGE}</Text>
      </VStack>
      {retryMarkup}
    </Page>
  );
}
